const host = window.location.hostname;

const API_BY_ENV = {
    "dev.aichat.arc.travel": "https://pfkuzkpvaa.execute-api.us-east-1.amazonaws.com",
    "qa.aichat.arc.travel": "https://vxtrmy94kj.execute-api.us-east-1.amazonaws.com",
    "uat.aichat.arc.travel": "https://2zrmh2b1ch.execute-api.us-east-1.amazonaws.com",
    "aichat.arc.travel": "https://etqltpu725.execute-api.us-east-1.amazonaws.com"
}

const API_BASE = API_BY_ENV[host] || "https://pfkuzkpvaa.execute-api.us-east-1.amazonaws.com";

export const ASSISTANTS = {
    confluence: {
        name: "Confluence Assistant",
        //apiUrl: "https://v6ahw9djch.execute-api.us-east-1.amazonaws.com",
        apiUrl: API_BASE,
        defaultModel: "claude3Sonnet",
        requiredRoles: ["ai_confluence_access"]
    }

    /*
    hr: {
        name: "HR Assistant",
        apiUrl: "https://ob5zew37za.execute-api.us-east-1.amazonaws.com",
        defaultModel: "novaPro",
        requiredRoles: ["ai_hr_access"]
        //API_URL = "https://ob5zew37za.execute-api.us-east-1.amazonaws.com"
    },
    arcci: {
        name: "ARC CI Assistant",
        apiUrl: "https://bwwhrr6awe.execute-api.us-east-1.amazonaws.com",
        defaultModel: "novaPro",
        requiredRoles: ["ai_arcci_access"]
    },
    roleprofiles: {
        name: "Role Profile Assistant",
        apiUrl: "https://i1q2rk76pb.execute-api.us-east-1.amazonaws.com",
        defaultModel: "novaPro",
        requiredRoles: ["ai_roleprofile_access"]
    },
    support: {
        name: "Support Assistant",
        apiUrl: "https://arc-api.com/support",
        defaultModel: "novaPro",
        requiredRoles: ["ai_support_access"]
    },
    general: {
        name: "General Assistant",
        apiUrl: "https://arc-api.com/general",
        defaultModel: "novaPro",
        requiredRoles: ["ai_general_access"]
    }
    */
    
}